import comp from '../components/barrel';

export const CONTACT_ROLES = [
  {value: 'Advisor', label: 'Advisor'},
  {value: 'Business owner', label: 'Business owner'},
  {value: 'Operational support', label: 'Operational support'},
  {value: 'Other', label: 'Other'},
];

export const LEAD_TYPES = [
  {value: 'organisation', label: 'Organisation'},
  {value: 'independent', label: 'Independent advisor'},
];

export const LEAD_SOURCES = [
  {value: 'Event', label: 'Event'},
  {value: 'Referral', label: 'Referral'},
  {value: 'Cold Call', label: 'Cold Call'},
  {value: 'Outsell', label: 'Outsell'},
  {value: 'Social media', label: 'Social media'},
  {value: 'Other', label: 'Other'},
];

export const SOCIAL_MEDIA_SOURCE = 'Social media';

export const SOCIAL_MEDIA_CHANNELS = [
  {value: 'Linkedin', label: 'Linkedin'},
  {value: 'Facebook', label: 'Facebook'},
  {value: 'Google', label: 'Google'},
  {value: 'Other', label: 'Other'},
];

function syncSocialMediaField(sourceEl, cell) {
  if (!cell) return;
  const show = !!(sourceEl && String(sourceEl.value || '').trim() === SOCIAL_MEDIA_SOURCE);
  cell.hidden = !show;
  const grid = cell.closest('.lead-top-grid');
  if (grid) grid.classList.toggle('has-social-media', show);
}

export function applySocialMediaVisibility() {
  syncSocialMediaField(U.id('leadSourceDD'), U.id('leadSocialMediaCell'));
}

export async function appendLeadSourceFields(parent, {initSource = '', initSocial = '', sourceClass = 'lead-source-field', socialClass = 'lead-top-social lead-top-social-col-2'} = {}) {
  const sourceCell = U.divAtt('div', 'class', sourceClass);
  sourceCell.appendChild(
    await comp.select_v2({
      elID: 'leadSourceDD',
      ddData: LEAD_SOURCES,
      valueDataName: 'value',
      textDataName: 'label',
      labelName: 'Source',
      requiredYN: 1,
      initValue: initSource,
    })
  );
  parent.appendChild(sourceCell);
  const socialCell = U.divAtt('div', 'class', socialClass);
  socialCell.id = 'leadSocialMediaCell';
  socialCell.hidden = true;
  socialCell.appendChild(
    await comp.select_v2({
      elID: 'leadSocialMediaDD',
      ddData: SOCIAL_MEDIA_CHANNELS,
      valueDataName: 'value',
      textDataName: 'label',
      labelName: 'Social media',
      requiredYN: 0,
      initValue: initSocial,
    })
  );
  parent.appendChild(socialCell);
  const sourceEl = sourceCell.querySelector('#leadSourceDD');
  if (sourceEl) sourceEl.addEventListener('change', () => syncSocialMediaField(sourceEl, socialCell));
  syncSocialMediaField(sourceEl, socialCell);
}

export const SOURCE_OF_LEAD_OTHER = 'other';

let contactSeq = 0;
let savedSnapshot = '';

function formSnapshot() {
  const data = collectLeadForm();
  const gate = U.id('addLeadMarketerDD');
  if (gate) data.gate_marketer = String(gate.value || '');
  return JSON.stringify(data);
}

export function markLeadFormClean() {
  if (!U.id('leadTypeDD')) {
    savedSnapshot = '';
    return;
  }
  savedSnapshot = formSnapshot();
  window.onbeforeunload = (event) => {
    if (!isLeadFormDirty()) return undefined;
    event.preventDefault();
    event.returnValue = '';
    return '';
  };
}

export function isLeadFormDirty() {
  if (!U.id('leadTypeDD') || !savedSnapshot) return false;
  return formSnapshot() !== savedSnapshot;
}

export function confirmLeaveLeadForm() {
  if (!isLeadFormDirty()) return true;
  return window.confirm('You have unsaved changes. Leave without saving?');
}

function val(id) {
  const el = U.id(id);
  return el ? String(el.value || '').trim() : '';
}

export async function mountLeadForm(container, {isMarketer, marketers, lead, showMarketer = true, showSource = false, showAttribution = false, showActive = false, onTypeChange = 'thsPage.onLeadTypeChange()'} = {}) {
  container.innerHTML = '';
  contactSeq = 0;
  const details = lead || {};
  const contacts = Array.isArray(details.contacts) && details.contacts.length ? details.contacts : [{}];

  const top = U.divAtt('div', 'class', 'lead-top-grid');
  const marketerCell = U.divAtt('div', 'class', 'lead-top-marketer');
  if (showMarketer && isMarketer) {
    const name = `${details.marketer_f_name || ''} ${details.marketer_s_name || ''}`.trim();
    marketerCell.appendChild(comp.displayText('leadMarketerDisplay', name || 'You', 'Marketer'));
  } else if (showMarketer) {
    marketerCell.appendChild(
      await comp.select_v2({
        elID: 'leadMarketerDD',
        ddData: marketers || [],
        valueDataName: 'user_uuid',
        textDataName: 'fullName',
        labelName: 'Marketer',
        requiredYN: 1,
        initValue: details.marketer_uuid || '',
      })
    );
  }
  if (marketerCell.childElementCount) top.appendChild(marketerCell);

  if (showSource || showAttribution) {
    await appendLeadSourceFields(top, {
      initSource: details.source || '',
      initSocial: details.social_media || '',
      sourceClass: showAttribution ? 'lead-top-source' : 'lead-top-marketer',
      socialClass: showAttribution ? 'lead-top-social lead-top-social-col-3' : 'lead-top-social lead-top-social-col-1',
    });
  }

  if (showAttribution && !isMarketer) {
    top.classList.add('has-attribution');
    const sourceOfCell = U.divAtt('div', 'class', 'lead-top-source-of');
    sourceOfCell.appendChild(
      await comp.select_v2({
        elID: 'leadSourceOfLeadDD',
        ddData: [{user_uuid: SOURCE_OF_LEAD_OTHER, fullName: 'Other/not marketer'}, ...(marketers || [])],
        valueDataName: 'user_uuid',
        textDataName: 'fullName',
        labelName: 'Source of lead',
        requiredYN: 1,
        initValue: details.marketersource || SOURCE_OF_LEAD_OTHER,
      })
    );
    top.appendChild(sourceOfCell);
  }

  const typeAtStart = !isMarketer && !marketerCell.childElementCount && !showSource;
  const typeCell = U.divAtt('div', 'class', typeAtStart ? 'lead-top-marketer' : 'lead-top-type');
  typeCell.appendChild(
    await comp.select_v2({
      elID: 'leadTypeDD',
      ddData: LEAD_TYPES,
      valueDataName: 'value',
      textDataName: 'label',
      labelName: 'Lead type',
      requiredYN: 1,
      initValue: details.lead_type || 'organisation',
      onchange: onTypeChange,
    })
  );
  top.appendChild(typeCell);

  if (showActive) {
    const activeWrap = U.divAtt('div', 'class', 'lead-header-active');
    const isActive = details.active_yn !== false && details.active_yn !== 'false' && details.active_yn !== 0;
    activeWrap.appendChild(
      await comp.toggle_v2({
        elID: 'leadActiveYN',
        isChecked: isActive,
        labelName: 'Active',
      })
    );
    top.appendChild(activeWrap);
  }

  const org = U.divAtt('div', 'id', 'leadOrgFields');
  org.className = 'lead-org-fields';
  const nameField = U.divAtt('div', 'class', 'lead-org-field lead-org-name');
  nameField.appendChild(await comp.inputText('leadOrgName', details.organisation_name || '', 'Organisation name', 1));
  const emailField = U.divAtt('div', 'class', 'lead-org-field lead-org-email');
  emailField.appendChild(await comp.inputText('leadOrgEmail', details.org_email || '', 'Organisation email', 0));
  const phoneField = U.divAtt('div', 'class', 'lead-org-field lead-org-phone');
  phoneField.appendChild(await comp.inputText('leadOrgPhone', details.org_phone || '', 'Organisation phone', 0));
  org.appendChild(nameField);
  org.appendChild(emailField);
  org.appendChild(phoneField);
  top.appendChild(org);
  container.appendChild(top);
  applySocialMediaVisibility();

  const peopleHead = document.createElement('h5');
  peopleHead.className = 'mt-4';
  peopleHead.textContent = 'People';
  container.appendChild(peopleHead);

  const people = U.divAtt('div', 'id', 'leadContacts');
  container.appendChild(people);
  for (const contact of contacts) {
    await addContactRow(people, contact);
  }

  const addBtn = document.createElement('button');
  addBtn.type = 'button';
  addBtn.id = 'addLeadContactBtn';
  addBtn.className = 'btn mt-2';
  addBtn.textContent = 'Add person';
  addBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    await addContactRow(U.id('leadContacts'), {});
    document.querySelectorAll('.lead-contact-remove-msg').forEach((el) => {
      el.hidden = true;
      el.textContent = '';
    });
    applyLeadTypeVisibility();
  });
  container.appendChild(addBtn);

  container.appendChild(await comp.textarea('leadNotes', details.notes || '', 'Notes', 0));
  applyLeadTypeVisibility();
  markLeadFormClean();
}

async function addContactRow(parent, contact) {
  const n = contactSeq;
  contactSeq += 1;
  const row = U.divAtt('div', 'class', 'res-grid-cols-3 lead-contact-row border-t pt-3 mt-3');
  row.dataset.contactId = contact.d_lead_contact_id != null ? String(contact.d_lead_contact_id) : '';
  row.appendChild(await comp.inputText(`leadFName_${n}`, contact.f_name || '', 'First name', 1));
  row.appendChild(await comp.inputText(`leadSName_${n}`, contact.s_name || '', 'Surname', 1));
  row.appendChild(await comp.inputText(`leadEmail_${n}`, contact.email_address || '', 'Email', 0));
  row.appendChild(await comp.inputText(`leadCell_${n}`, contact.cell_nr || '', 'Cell number', 0));
  const areaField = await comp.inputText(`leadAreaRegion_${n}`, contact.area_region || '', 'Area/region', 1);
  areaField.classList.add('lead-area-region');
  const areaInput = areaField.querySelector(`#leadAreaRegion_${n}`);
  if (areaInput) {
    areaInput.minLength = 3;
    areaInput.maxLength = 30;
  }
  row.appendChild(areaField);
  const listedRoles = CONTACT_ROLES.filter((role) => role.value !== 'Other').map((role) => role.value);
  const storedRole = String(contact.contact_role || '').trim();
  const isListedRole = listedRoles.includes(storedRole);
  const roleValue = storedRole ? (isListedRole ? storedRole : 'Other') : 'Advisor';
  row.appendChild(
    await comp.select_v2({
      elID: `leadRole_${n}`,
      ddData: CONTACT_ROLES,
      valueDataName: 'value',
      textDataName: 'label',
      labelName: 'Role',
      requiredYN: 1,
      initValue: roleValue,
    })
  );
  const otherWrap = U.divAtt('div', 'class', 'lead-role-other');
  otherWrap.id = `leadRoleOtherWrap_${n}`;
  otherWrap.hidden = roleValue !== 'Other';
  otherWrap.appendChild(await comp.inputText(`leadRoleOther_${n}`, isListedRole ? '' : storedRole, 'Other role', 0, null, 'Describe the role'));
  row.appendChild(otherWrap);
  const roleEl = row.querySelector(`#leadRole_${n}`);
  if (roleEl) {
    roleEl.addEventListener('change', () => {
      otherWrap.hidden = roleEl.value !== 'Other';
    });
  }

  const primaryWrap = U.divAtt('div', 'class', 'flex items-center gap-2');
  const primary = document.createElement('input');
  primary.type = 'radio';
  primary.name = 'leadPrimary';
  primary.id = `leadPrimary_${n}`;
  primary.checked = !!contact.primary_yn || parent.childElementCount === 0;
  const primaryLabel = document.createElement('label');
  primaryLabel.htmlFor = primary.id;
  primaryLabel.textContent = 'Primary contact';
  primaryWrap.appendChild(primary);
  primaryWrap.appendChild(primaryLabel);
  row.appendChild(primaryWrap);

  const removeWrap = U.divAtt('div', 'class', 'flex items-center gap-2');
  const removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'btn-outline lead-contact-remove';
  removeBtn.textContent = 'Remove';
  const removeMsg = document.createElement('span');
  removeMsg.className = 'lead-contact-remove-msg';
  removeMsg.hidden = true;
  removeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const rows = parent.querySelectorAll('.lead-contact-row');
    if (rows.length <= 1) {
      removeMsg.textContent = 'There must be at least one person in a lead';
      removeMsg.hidden = false;
      return;
    }
    row.remove();
    parent.querySelectorAll('.lead-contact-remove-msg').forEach((el) => {
      el.hidden = true;
      el.textContent = '';
    });
    const radios = parent.querySelectorAll('input[name="leadPrimary"]');
    if (radios.length && ![...radios].some((r) => r.checked)) radios[0].checked = true;
  });
  removeWrap.appendChild(removeBtn);
  removeWrap.appendChild(removeMsg);
  row.appendChild(removeWrap);
  parent.appendChild(row);
}

export function applyLeadTypeVisibility() {
  const type = val('leadTypeDD') || 'organisation';
  const addBtn = U.id('addLeadContactBtn');
  const isOrg = type === 'organisation';
  document.querySelectorAll('#leadOrgFields .lead-org-field').forEach((field) => {
    field.style.display = isOrg ? '' : 'none';
  });
  if (addBtn) addBtn.style.display = isOrg ? '' : 'none';
  if (!isOrg) {
    const rows = document.querySelectorAll('#leadContacts .lead-contact-row');
    rows.forEach((row, index) => {
      if (index > 0) row.remove();
    });
    const radio = document.querySelector('#leadContacts input[name="leadPrimary"]');
    if (radio) radio.checked = true;
  }
  document.querySelectorAll('.lead-contact-remove').forEach((btn) => {
    btn.style.display = isOrg ? '' : 'none';
  });
}

export function collectLeadForm() {
  const lead_type = val('leadTypeDD');
  const contacts = [...document.querySelectorAll('#leadContacts .lead-contact-row')].map((row) => {
    const id = (el) => (el ? String(el.value || '').trim() : '');
    const f = row.querySelector('input[id^="leadFName_"]');
    const s = row.querySelector('input[id^="leadSName_"]');
    const email = row.querySelector('input[id^="leadEmail_"]');
    const cell = row.querySelector('input[id^="leadCell_"]');
    const area = row.querySelector('input[id^="leadAreaRegion_"]');
    const role = row.querySelector('select[id^="leadRole_"]');
    const otherRole = row.querySelector('input[id^="leadRoleOther_"]');
    const primary = row.querySelector('input[name="leadPrimary"]');
    const contactId = row.dataset.contactId ? parseInt(row.dataset.contactId, 10) : null;
    const selectedRole = id(role);
    return {
      d_lead_contact_id: Number.isInteger(contactId) && contactId > 0 ? contactId : null,
      f_name: id(f),
      s_name: id(s),
      email_address: id(email) || null,
      cell_nr: id(cell) || null,
      area_region: id(area),
      contact_role: selectedRole === 'Other' ? id(otherRole) : selectedRole,
      primary_yn: !!(primary && primary.checked),
    };
  });
  const marketerEl = U.id('leadMarketerDD');
  const activeEl = U.id('leadActiveYN');
  const payload = {
    lead_type,
    organisation_name: lead_type === 'organisation' ? val('leadOrgName') : null,
    org_email: lead_type === 'organisation' ? val('leadOrgEmail') || null : null,
    org_phone: lead_type === 'organisation' ? val('leadOrgPhone') || null : null,
    marketer_uuid: marketerEl ? val('leadMarketerDD') : null,
    notes: val('leadNotes') || null,
    contacts,
  };
  if (activeEl) payload.active_yn = !!activeEl.checked;
  if (U.id('leadSourceDD')) {
    const source = val('leadSourceDD') || null;
    payload.source = source;
    payload.social_media = source === SOCIAL_MEDIA_SOURCE ? val('leadSocialMediaDD') || null : null;
  }
  if (U.id('leadSourceOfLeadDD')) payload.source_of_lead = val('leadSourceOfLeadDD') || null;
  return payload;
}

export function validateLeadForm(payload) {
  if (U.id('leadSourceDD') && !val('leadSourceDD')) return 'Source is required';
  if (val('leadSourceDD') === SOCIAL_MEDIA_SOURCE && !val('leadSocialMediaDD')) return 'Choose Linkedin, Facebook, Google, or Other';
  if (U.id('leadSourceOfLeadDD') && !payload.source_of_lead) return 'Source of lead is required';
  if (!payload.lead_type) return 'Lead type is required';
  if (payload.lead_type === 'organisation' && !payload.organisation_name) return 'Organisation name is required';
  if (!payload.contacts.length) return 'At least one person is required';
  const otherRoleMissing = [...document.querySelectorAll('#leadContacts .lead-contact-row')].some((row) => {
    const role = row.querySelector('select[id^="leadRole_"]');
    const other = row.querySelector('input[id^="leadRoleOther_"]');
    return role && role.value === 'Other' && !(other && String(other.value || '').trim());
  });
  if (otherRoleMissing) return 'Describe the other role';
  for (const contact of payload.contacts) {
    if (!contact.f_name || !contact.s_name) return 'Each person needs a first name and surname';
    if (!contact.area_region || contact.area_region.length < 3 || contact.area_region.length > 30) {
      return 'Each person needs an area/region of 3 to 30 characters';
    }
    if (!contact.contact_role) return 'Each person needs a role';
  }
  return '';
}
